// extracted by mini-css-extract-plugin
export default {"LanguageToggler":"LanguageToggler_LanguageToggler__UhGmj"};